<template>
    <v-row align="center" class="px-3">
        <v-btn fab text small @click="$emit('prev')" color="#333333">
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer/>
        <span class="calendar-title">
            {{ title }}
        </span>
        <v-spacer/>
        <v-btn fab text small @click="$emit('next')" color="#333333">
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </v-row>
</template>

<script>
export default {
    name: "MonthSelector",
    props: {
        title: {
            type: String,
            default: '',
        }
    }
}
</script>

<style scoped>

.calendar-title {
    text-transform: capitalize;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
}

</style>